import CustomButton from 'components/Buttons/CustomButton'
import LoadingAnimation from 'components/LoadingAnimation'
import { useEffect, useState } from 'react'
import { ArrowRight, Edit2, Trash, User, FileText } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useOutletContext } from 'react-router-dom'
import {
  Alert,
  Card,
  CardBody,
  CardText,
  Col,
  Collapse,
  Input,
  ListGroup,
  ListGroupItem,
  Row,
  Spinner,
} from 'reactstrap'
import axios from 'axios'
import { postEditEmploymentData, postEditProfile } from '../settingAction'
import {
  useFetchSettingsQuery,
  useGetUserAvatarQuery,
} from '../settingApiSlice'
import { setIsEdit } from '../settingSlice'
import ModalAvatarUpload from './ModalAvatarUpload'
import ModalConfirmasi from './ModalConfirmasi'
import './modalStyle.scss'
import { settingRoutes } from 'routes/settingRoutes'
import { MANAGE } from 'utils/subjectActions'
import { URL_EVENT } from 'utils/pathUrl'
import { useSnackbar } from 'notistack'
import Flatpickr from 'react-flatpickr'
import PMBSearchInputGroup from 'components/PMBSearchInputGroup'
import { useUploadImagePublicMutation } from '../settingApiSlice'
import PMBSelect from 'components/PMBSelect'
import { P } from 'components'
import PMBProfilePic from 'components/PMBProfilePic'

const ProfileSetting = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [name, setName] = useState('')
  const [employmentForm, setEmploymentForm] = useState({})
  const [isEditEmployment, setIsEditEmployment] = useState(false)
  const [isEmploymentOpen, setIsEmploymentOpen] = useState(false)
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [isSuccessUploadAva, setIsSuccessUploadAva] = useState(false)
  const [tempUserId, setTempUserId] = useState(null)
  const { enqueueSnackbar } = useSnackbar()
  // remove photo
  const [isOpenRemovePhoto, setIsOpenRemovePhoto] = useState(false)
  const [data, isLoading, isSuccess] = useOutletContext()
  const { data: avaUser, refetch: refetchAvatar } = useGetUserAvatarQuery(
    tempUserId,
    {
      skip: tempUserId === null,
    },
  )
  const [uploadImagePublic] = useUploadImagePublicMutation()
  const [contractFile, setContractFile] = useState(null)
  const [insuranceFile, setInsuranceFile] = useState(null)
  const [isSavingEmployment, setIsSavingEmployment] = useState(false)
  const [isDownloadingContract, setIsDownloadingContract] = useState(false)
  const [isDownloadingInsurance, setIsDownloadingInsurance] = useState(false)
  const { abilityRole } = useSelector((s) => s.auth)
  const { token, id: authId } = useSelector((s) => s.auth)
  const { profile } = useSelector((s) => s.dashboard)
  const { isEdit } = useSelector((s) => s.setting)
  const { refetch } = useFetchSettingsQuery()

  const modifiedSettingRoutes = settingRoutes.map((item) => {
    if (item.path === URL_EVENT || item.path?.includes('event')) {
      return {
        ...item,
        to: `${item.path}?userId=${profile?.userId ?? ''}`,
        path: `${item.path}?userId=${profile?.userId ?? ''}`,
      }
    }
    return item
  })

  const hanldeEditProfile = async (name) => {
    try {
      const data = await dispatch(postEditProfile({ name: name }))
      if (data.payload.error === 0) {
        refetch()
        dispatch(setIsEdit(false))
        enqueueSnackbar('Profil berhasil diperbarui.', { variant: 'success' })
      } else {
        throw data
      }
    } catch (error) {
      enqueueSnackbar(
        error?.payload || error?.message || 'Gagal memperbarui profil',
        { variant: 'error' },
      )
    }
  }

  const cleanObject = (obj) => {
    const out = {}
    Object.entries(obj || {}).forEach(([k, v]) => {
      if (v === '' || v === null || v === undefined) return
      out[k] = v
    })
    return out
  }

  const handleSaveEmployment = async () => {
    if (isSavingEmployment) return
    setIsSavingEmployment(true)
    try {
      const nameToSend = data?.makerData?.name || name || ''
      const profilepicUrlToSend =
        avaUser?.data?.[0]?.link || profile?.profilePic || null

      const employmentData = { ...(employmentForm || {}) }

      if (contractFile) {
        try {
          const up = await uploadImagePublic(contractFile).unwrap()
          const contractUrl =
            up?.url ||
            up?.data?.url ||
            up?.data?.meta?.url ||
            up?.data?.data?.url ||
            null
          if (contractUrl) employmentData.contractImgs = contractUrl
        } catch (err) {
          enqueueSnackbar(
            err?.data?.meta?.message ||
              err?.message ||
              'Gagal mengunggah dokumen kontrak',
            { variant: 'error' },
          )
          return
        }
      }

      if (insuranceFile) {
        try {
          const up2 = await uploadImagePublic(insuranceFile).unwrap()
          const insuranceUrl =
            up2?.url ||
            up2?.data?.url ||
            up2?.data?.meta?.url ||
            up2?.data?.data?.url ||
            null
          if (insuranceUrl) employmentData.insuranceImgs = insuranceUrl
        } catch (err) {
          enqueueSnackbar(
            err?.data?.meta?.message ||
              err?.message ||
              'Gagal mengunggah dokumen asuransi',
            { variant: 'error' },
          )
          return
        }
      }

      // clean employmentData and only include non-empty keys
      const cleanedEmployment = cleanObject(employmentData)

      const payload = {}
      if (nameToSend) payload.name = nameToSend
      if (profilepicUrlToSend !== null && profilepicUrlToSend !== undefined)
        payload.profilePicUrl = profilepicUrlToSend
      if (Object.keys(cleanedEmployment).length)
        payload.employmentData = cleanedEmployment

      const res = await dispatch(postEditEmploymentData(payload))
      if (res?.payload?.error === 0) {
        enqueueSnackbar('Data ketenagakerjaan berhasil disimpan.', {
          variant: 'success',
        })
        setIsEditEmployment(false)
        setContractFile(null)
        setInsuranceFile(null)
        refetch()
      } else if (res?.error) {
        // try to surface better error message
        const msg =
          res?.payload?.message || res?.error?.message || 'Gagal menyimpan data'
        throw new Error(msg)
      } else {
        enqueueSnackbar('Data ketenagakerjaan berhasil disimpan.', {
          variant: 'success',
        })
        setIsEditEmployment(false)
        setContractFile(null)
        setInsuranceFile(null)
        refetch()
      }
    } catch (error) {
      enqueueSnackbar(
        error?.payload || error?.message || 'Gagal menyimpan data',
        { variant: 'error' },
      )
    } finally {
      setIsSavingEmployment(false)
    }
  }

  const fnShowModalAddPhoto = () => {
    setIsOpenModal(!isOpenModal)
  }

  const fnShowModalRemoveFoto = () => {
    setIsOpenRemovePhoto(!isOpenRemovePhoto)
  }

  const downloadFile = async (url, setLoading) => {
    if (!url) return
    setLoading(true)
    try {
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      })

      let filename = 'dokumen.pdf'
      const disposition = response.headers['content-disposition']
      if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        const matches = filenameRegex.exec(disposition)
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, '')
        }
      }

      const blobFile = new Blob([response.data], {
        type: response.data?.type || 'application/pdf',
      })
      const downloadUrl = window.URL.createObjectURL(blobFile)
      const a = document.createElement('a')
      a.href = downloadUrl
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(downloadUrl)
    } catch (err) {
      enqueueSnackbar(err?.message || 'Gagal mengunduh dokumen', {
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (data?.makerData?.userId) {
      setTempUserId([data?.makerData?.userId])
    }
  }, [data?.makerData?.userId])

  useEffect(() => {
    const ed = data?.makerData?.employmentData || data?.employmentData || null
    if (ed) {
      setEmploymentForm({
        contractId: ed.contractId || '',
        contractStartDate: ed.contractStartDate || '',
        contractEndDate: ed.contractEndDate || '',
        contractImgs: ed.contractImgs || '',
        employment_insurance_number: ed.employment_insurance_number,
        health_insurance_number: ed.health_insurance_number || '',
        insuranceCoverage: ed.insuranceCoverage || '',
        insuranceImgs: ed.insuranceImgs || '',
        employmentType: ed.employmentType || '',
        dayOfBirth: ed.dayOfBirth || '',
      })
    }
  }, [data?.makerData?.employmentData, data?.employmentData])

  const formatDateISO = (d) => {
    if (!d) return ''
    const date = d instanceof Date ? d : new Date(d)
    const yyyy = date.getFullYear()
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const dd = String(date.getDate()).padStart(2, '0')
    return `${yyyy}-${mm}-${dd}`
  }

  const groupedSettings = modifiedSettingRoutes.reduce((acc, curr) => {
    if (!acc[curr.category]) acc[curr.category] = []
    acc[curr.category].push(curr)
    return acc
  }, {})

  const checkAbility = (action, subjects) => {
    return abilityRole.some((ability) => {
      if (ability.subject === 'all' || ability.subject === 'business_all') {
        return true
      }

      if (Array.isArray(subjects)) {
        return (
          subjects.includes(ability.subject) &&
          (ability.action === action || ability.action === MANAGE)
        )
      }

      return (
        ability.subject === subjects &&
        (ability.action === action || ability.action === MANAGE)
      )
    })
  }

  const filterItems = (category, items) => {
    return items.filter((item) => {
      const showIf = item.showIf ? item.showIf(data) : true
      return (item.alwaysShow || checkAbility(item.action, item.subject)) && showIf
    })
  }

  return (
    <>
      <ModalAvatarUpload
        toggle={fnShowModalAddPhoto}
        modal={isOpenModal}
        centered={true}
        keyboard={false}
        backdrop="static"
        setIsSuccessUploadAva={setIsSuccessUploadAva}
        dataName={data?.makerData?.name ?? data?.makerData?.email}
        refetchAvatar={refetchAvatar}
      />

      <ModalConfirmasi
        toggle={fnShowModalRemoveFoto}
        modal={isOpenRemovePhoto}
        centered={true}
        keyboard={false}
        backdrop="static"
        dataName={data?.makerData?.name ?? data?.makerData?.email}
        setIsSuccessUploadAva={setIsSuccessUploadAva}
        refetchAvatar={refetchAvatar}
      />
      <CardBody>
        <Alert
          color="info"
          isOpen={isSuccessUploadAva ? true : false}
          toggle={() => setIsSuccessUploadAva(false)}
          className="px-3"
        >
          <span>{isSuccessUploadAva}</span>
        </Alert>
        <Row>
          <Col sm="12" md="2" lg="3" className="flex-centered">
            {!isLoading && isSuccess ? (
              <div className="d-flex justfy-content-center align-items-center flex-column gap-2">
                <PMBProfilePic
                  testId="profile-avatar"
                  imgSrc={avaUser?.data?.[0]?.link}
                  altText="avatar"
                  name={profile?.name || profile?.fullName}
                  avatarSeed={authId}
                  width={120}
                  height={120}
                />
                
                {Object.values(avaUser?.data ?? [])?.length > 0 ? (
                  <div className="d-flex gap-2 w-100 mt-2">
                    <CustomButton
                      color="primary"
                      outline
                      size="sm"
                      className="flex-fill"
                      testId="profile-avatar-upload"
                      onClick={() => {
                        fnShowModalAddPhoto()
                        setIsSuccessUploadAva(false)
                      }}
                    >
                      <Edit2 size={14} style={{ marginRight: 4 }} />
                      Ubah Foto
                    </CustomButton>

                    <CustomButton
                      color="danger"
                      outline
                      size="sm"
                      className="flex-fill"
                      testId="profile-avatar-remove"
                      onClick={fnShowModalRemoveFoto}
                    >
                      <Trash size={14} style={{ marginRight: 4 }} />
                      Hapus Foto
                    </CustomButton>
                  </div>
                ) : (
                  <CustomButton
                    color="secondary"
                    outline
                    size="sm"
                    className="w-100 mt-2"
                    testId="profile-avatar-upload"
                    onClick={fnShowModalAddPhoto}
                  >
                    Tambah Foto
                  </CustomButton>
                )}
              </div>
            ) : (
              <LoadingAnimation size="sm" />
            )}
          </Col>
          <Col sm="12" md="10" lg="9">
            <ListGroup flush>
              <ListGroupItem className="py-4 mt-3">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <CardText tag="h4">Informasi profil</CardText>
                    <CardText tag="p">
                      Ubah profil dan foto Anda di sini
                    </CardText>
                  </div>
                  <div className="d-flex gap-2">
                    <div className="profile-action-buttons d-flex gap-2 w-100 flex-column flex-md-row">
                      <CustomButton
                        color="primary"
                        outline
                        size="sm"
                        className="w-100 w-md-auto"
                        testId="profile-edit-button"
                        onClick={() => {
                          dispatch(setIsEdit(isEdit ? false : true))
                        }}
                      >
                        {!isEdit ? (
                          <Edit2 size={14} style={{ marginRight: 4 }} />
                        ) : null}
                        {isEdit ? 'Kembali' : 'Ubah'}
                      </CustomButton>
                      {isEdit ? (
                        <CustomButton
                          disabled={!name}
                          color="primary"
                          className="w-100 w-md-auto"
                          testId="profile-save-button"
                          onClick={() => hanldeEditProfile(name)}
                        >
                          Simpan
                        </CustomButton>
                      ) : null}
                    </div>
                  </div>
                </div>
              </ListGroupItem>
              <ListGroupItem className="py-4">
                <Row>
                  <Col sm="4">Nama</Col>
                  <Col sm="8">
                    {!isLoading && isSuccess ? (
                      isEdit ? (
                        <Input
                          type="text"
                          data-testid="profile-name-input"
                          onChange={(e) => setName(e.target.value)}
                          defaultValue={data?.makerData?.name}
                        />
                      ) : (
                        data?.makerData?.name
                      )
                    ) : (
                      <LoadingAnimation size="sm" />
                    )}
                  </Col>
                </Row>
              </ListGroupItem>
              <ListGroupItem className="py-4">
                <Row>
                  <Col sm="4">Alamat Email</Col>
                  <Col sm="8">
                    {!isLoading && isSuccess ? (
                      isEdit ? (
                        <Input
                          type="text"
                          onChange={(e) => setName(e.target.value)}
                          value={data?.makerData?.email}
                          disabled
                        />
                      ) : (
                        data?.makerData?.email
                      )
                    ) : (
                      <LoadingAnimation size="sm" />
                    )}
                  </Col>
                </Row>
              </ListGroupItem>
              <ListGroupItem className="py-4">
                <Row>
                  <Col sm="4">Peran</Col>
                  <Col sm="8">
                    {!isLoading && isSuccess ? (
                      isEdit ? (
                        <Input
                          type="text"
                          onChange={(e) => setName(e.target.value)}
                          value={data?.makerData?.rolesName}
                          disabled
                        />
                      ) : (
                        data?.makerData?.rolesName
                      )
                    ) : (
                      <LoadingAnimation size="sm" />
                    )}
                  </Col>
                </Row>
              </ListGroupItem>
              <ListGroupItem className="py-4">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <CardText tag="h4">Informasi Ketenagakerjaan</CardText>
                    <CardText tag="p">
                      Data kontrak, asuransi, dan tipe pekerjaan Anda.
                    </CardText>
                    {!isEditEmployment && (
                      <small className="text-muted">
                        {employmentForm.employmentType || '-'}
                        {employmentForm.contractId
                          ? ` • ${employmentForm.contractId}`
                          : ''}
                        {employmentForm.employment_insurance_number
                          ? employmentForm.employment_insurance_number
                          : '-'}
                      </small>
                    )}
                  </div>
                  <div className="d-flex gap-2">
                    <div className="profile-action-buttons d-flex gap-2 w-100 flex-column flex-md-row">
                      <CustomButton
                        color="secondary"
                        outline
                        size="sm"
                        className="w-100 w-md-auto"
                        testId="profile-employment-toggle-button"
                        onClick={() => setIsEmploymentOpen((v) => !v)}
                      >
                        {isEmploymentOpen
                          ? 'Sembunyikan detail'
                          : 'Lihat detail'}
                      </CustomButton>
                      <CustomButton
                        color="primary"
                        outline
                        size="sm"
                        className="w-100 w-md-auto"
                        testId="profile-employment-edit-button"
                        onClick={() => {
                          setIsEditEmployment((v) => !v)
                          setIsEmploymentOpen(true)
                        }}
                      >
                        {isEditEmployment ? 'Kembali' : 'Ubah'}
                      </CustomButton>
                      {isEditEmployment ? (
                        <CustomButton
                          color="primary"
                          className="w-100 w-md-auto"
                          testId="profile-employment-save-button"
                          onClick={handleSaveEmployment}
                          disabled={isSavingEmployment}
                        >
                          {isSavingEmployment ? 'Menyimpan...' : 'Simpan'}
                        </CustomButton>
                      ) : null}
                    </div>
                  </div>
                </div>
              </ListGroupItem>
              <Collapse isOpen={isEmploymentOpen}>
                <div
                  style={{
                    border: '1px solid #eee',
                    borderRadius: '8px',
                    padding: '16px',
                    marginTop: '8px',
                  }}
                >
                  <Row className="gy-3">
                    <Col md="6">
                      <P>Nomor Kontrak</P>
                      {isEditEmployment ? (
                        <Input
                          placeholder="Masukkan nomor kontrak"
                          data-testid="profile-contract-id-input"
                          value={employmentForm.contractId || ''}
                          onChange={(e) =>
                            setEmploymentForm((p) => ({
                              ...p,
                              contractId: e.target.value,
                            }))
                          }
                        />
                      ) : (
                        employmentForm.contractId || '-'
                      )}
                    </Col>
                    <Col md="3">
                      <P>Tanggal Mulai</P>
                      {isEditEmployment ? (
                        <Flatpickr
                          placeholder="Tanggal mulai"
                          data-testid="profile-contract-start-date"
                          value={
                            employmentForm.contractStartDate
                              ? new Date(employmentForm.contractStartDate)
                              : ''
                          }
                          options={{ dateFormat: 'Y-m-d' }}
                          onChange={(dates) =>
                            setEmploymentForm((p) => ({
                              ...p,
                              contractStartDate: dates[0]
                                ? formatDateISO(dates[0])
                                : '',
                            }))
                          }
                          className="form-control"
                        />
                      ) : (
                        employmentForm.contractStartDate || '-'
                      )}
                    </Col>
                    <Col md="3">
                      <P>Tanggal Berakhir</P>
                      {isEditEmployment ? (
                        <Flatpickr
                          placeholder="Tanggal berakhir"
                          data-testid="profile-contract-end-date"
                          value={
                            employmentForm.contractEndDate
                              ? new Date(employmentForm.contractEndDate)
                              : ''
                          }
                          options={{ dateFormat: 'Y-m-d' }}
                          onChange={(dates) =>
                            setEmploymentForm((p) => ({
                              ...p,
                              contractEndDate: dates[0]
                                ? formatDateISO(dates[0])
                                : '',
                            }))
                          }
                          className="form-control"
                        />
                      ) : (
                        employmentForm.contractEndDate || '-'
                      )}
                    </Col>
                    <Col md="6">
                      <P>Dokumen Kontrak</P>
                      <div className="file-input-wrapper">
                        {isEditEmployment ? (
                          <label className="file-button">
                            Browse...
                            <input
                              type="file"
                              data-testid="profile-contract-file-input"
                              accept=".jpg,.png,.jpeg,.pdf"
                              onChange={(e) =>
                                setContractFile(e.target.files?.[0] || null)
                              }
                            />
                          </label>
                        ) : null}

                        <div>
                          {isEditEmployment ? (
                            contractFile ? (
                              <small>{contractFile.name}</small>
                            ) : employmentForm.contractImgs ? (
                              <CustomButton
                                color="secondary"
                                outline
                                size="sm"
                                onClick={() =>
                                  downloadFile(
                                    employmentForm.contractImgs,
                                    setIsDownloadingContract,
                                  )
                                }
                                disabled={isDownloadingContract}
                              >
                                {isDownloadingContract ? (
                                  <Spinner size="sm" className="me-1" />
                                ) : (
                                  <FileText size={14} className="me-1" />
                                )}
                                Lihat dokumen yang ada
                              </CustomButton>
                            ) : (
                              <small className="text-muted">
                                Belum ada dokumen
                              </small>
                            )
                          ) : employmentForm.contractImgs ? (
                            <CustomButton
                              color="secondary"
                              outline
                              size="sm"
                              onClick={() =>
                                downloadFile(
                                  employmentForm.contractImgs,
                                  setIsDownloadingContract,
                                )
                              }
                              disabled={isDownloadingContract}
                            >
                              {isDownloadingContract ? (
                                <Spinner size="sm" className="me-1" />
                              ) : (
                                <FileText size={14} className="me-1" />
                              )}
                              Lihat dokumen
                            </CustomButton>
                          ) : (
                            '-'
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col md="6">
                      <P>Nomor BPJS TK</P>
                      {isEditEmployment ? (
                        <Input
                          placeholder="Cari nomor BPJS TK"
                          data-testid="profile-bpjs-tk-input"
                          value={employmentForm.employment_insurance_number}
                          onChange={(e) =>
                            setEmploymentForm((p) => ({
                              ...p,
                              employment_insurance_number: e.target.value,
                            }))
                          }
                        />
                      ) : (
                        employmentForm.employment_insurance_number || '-'
                      )}
                    </Col>
                    {/* <Col md="6">
                      <P>Jenis Pertanggungan</P>
                      {isEditEmployment ? (
                        <Input
                          placeholder="Masukkan jenis pertanggungan"
                          value={employmentForm.insuranceCoverage || ''}
                          onChange={(e) =>
                            setEmploymentForm((p) => ({
                              ...p,
                              insuranceCoverage: e.target.value,
                            }))
                          }
                        />
                      ) : (
                        employmentForm.insuranceCoverage || '-'
                      )}
                    </Col> */}
                    {/* <Col md="6">
                      <P>Dokumen Asuransi</P>
                      <div className="file-input-wrapper">
                        {isEditEmployment ? (
                          <label className="file-button">
                            Browse...
                            <input
                              type="file"
                              accept=".jpg,.png,.jpeg,.pdf"
                              onChange={(e) =>
                                setInsuranceFile(e.target.files?.[0] || null)
                              }
                            />
                          </label>
                        ) : null}

                        <div>
                          {isEditEmployment ? (
                            insuranceFile ? (
                              <small>{insuranceFile.name}</small>
                            ) : employmentForm.insuranceImgs ? (
                              <CustomButton
                                color="secondary"
                                outline
                                size="sm"
                                onClick={() =>
                                  downloadFile(
                                    employmentForm.insuranceImgs,
                                    setIsDownloadingInsurance,
                                  )
                                }
                                disabled={isDownloadingInsurance}
                              >
                                {isDownloadingInsurance ? (
                                  <Spinner size="sm" className="me-1" />
                                ) : (
                                  <FileText size={14} className="me-1" />
                                )}
                                Lihat dokumen yang ada
                              </CustomButton>
                            ) : (
                              <small className="text-muted">
                                Belum ada dokumen
                              </small>
                            )
                          ) : employmentForm.insuranceImgs ? (
                            <CustomButton
                              color="secondary"
                              outline
                              size="sm"
                              onClick={() =>
                                downloadFile(
                                  employmentForm.insuranceImgs,
                                  setIsDownloadingInsurance,
                                )
                              }
                              disabled={isDownloadingInsurance}
                            >
                              {isDownloadingInsurance ? (
                                <Spinner size="sm" className="me-1" />
                              ) : (
                                <FileText size={14} className="me-1" />
                              )}
                              Lihat dokumen
                            </CustomButton>
                          ) : (
                            '-'
                          )}
                        </div>
                      </div>
                    </Col> */}
                    <Col md="6">
                      <P>Tipe Pekerjaan</P>
                      {isEditEmployment ? (
                        <PMBSelect
                          testId="profile-employment-type-select"
                          placeholder="Pilih tipe pekerjaan"
                          options={[
                            { value: 'FULLTIME', label: 'Fulltime' },
                            { value: 'PARTTIME', label: 'Parttime' },
                          ]}
                          value={
                            employmentForm.employmentType
                              ? {
                                  value: employmentForm.employmentType,
                                  label:
                                    employmentForm.employmentType === 'FULLTIME'
                                      ? 'Fulltime'
                                      : 'Parttime',
                                }
                              : null
                          }
                          onChange={(opt) =>
                            setEmploymentForm((p) => ({
                              ...p,
                              employmentType: opt?.value || '',
                            }))
                          }
                        />
                      ) : employmentForm.employmentType ? (
                        employmentForm.employmentType === 'FULLTIME' ? (
                          'Fulltime'
                        ) : employmentForm.employmentType === 'PARTTIME' ? (
                          'Parttime'
                        ) : (
                          employmentForm.employmentType
                        )
                      ) : (
                        '-'
                      )}
                    </Col>
                    <Col md="6">
                      <P>Nomor BPJS KES/KIS</P>
                      {isEditEmployment ? (
                        <Input
                          placeholder="Cari nomor BPJS KES/KIS"
                          data-testid="profile-bpjs-kes-input"
                          value={employmentForm.health_insurance_number || ''}
                          onChange={(e) =>
                            setEmploymentForm((p) => ({
                              ...p,
                              health_insurance_number: e.target.value,
                            }))
                          }
                          maxWidth="100%"
                        />
                      ) : (
                        employmentForm.health_insurance_number || '-'
                      )}
                    </Col>
                    <Col md="6">
                      <P>Tanggal Lahir</P>
                      {isEditEmployment ? (
                        <Flatpickr
                          placeholder="Tanggal lahir"
                          data-testid="profile-day-of-birth"
                          value={
                            employmentForm.dayOfBirth
                              ? new Date(employmentForm.dayOfBirth)
                              : ''
                          }
                          options={{ dateFormat: 'Y-m-d' }}
                          onChange={(dates) =>
                            setEmploymentForm((p) => ({
                              ...p,
                              dayOfBirth: dates[0]
                                ? formatDateISO(dates[0])
                                : '',
                            }))
                          }
                          className="form-control"
                        />
                      ) : (
                        employmentForm.dayOfBirth || '-'
                      )}
                    </Col>
                  </Row>
                </div>
              </Collapse>
            </ListGroup>
          </Col>
          <div className="mt-4 px-3">
            {Object.entries(groupedSettings).map(([category, items]) => {
              const filteredItems = filterItems(category, items)

              if (filteredItems.length === 0) return null

              return (
                <div key={category}>
                  <h5 className="mb-3">{category}</h5>
                  <Row>
                    {filteredItems.map((item, index) => (
                      <Col
                        md="12"
                        className="mb-3"
                        key={`${category}-${index}`}
                      >
                        <Card
                          className="border-1"
                          style={{
                            cursor: 'pointer',
                            transition: '0.3s',
                            borderColor: '#dee2e6',
                          }}
                          onClick={() =>
                            navigate(item.to, { state: { from: 'settings' } })
                          }
                        >
                          <CardBody className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                              <div className="me-3 card-icon">{item.icon}</div>
                              <div>
                                <h6 className="mb-1">{item.title}</h6>
                                <small>{item.description}</small>
                              </div>
                            </div>
                            <ArrowRight className="arrow-icon" color="#aaa" />
                          </CardBody>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </div>
              )
            })}
          </div>
        </Row>
      </CardBody>
    </>
  )
}

export default ProfileSetting
